export const getYoutubeEmbedLink = (link: string) => {
  const videoId = getYoutubeVideoId(link);

  return addQueryParams(`https://www.youtube.com/embed/${videoId}`, {
    autoplay: '1',
    enablejsapi: '1',
  });
};

export const getYoutubeVideoId = (link: string) => {
  const url = new URL(link);
  if (url.searchParams.get('v')) {
    return url.searchParams.get('v') ?? '';
  }
  return url.pathname.split('/').pop() ?? '';
};

const addQueryParams = (url: string, params: Record<string, string>) => {
  const urlObj = new URL(url); // Handles relative URLs safely

  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value); // `set` will add or replace existing params
  });

  return urlObj.toString();
};
